/**
 * Work Item Links API (FLOW-433)
 */
import { api } from "./client";
import type {
  CreateWorkItemLinkRequest,
  WorkItemId,
  WorkItemLink,
  WorkItemLinkListResponse,
} from "./types";

export async function listWorkItemLinks(
  workItemId: WorkItemId,
): Promise<WorkItemLinkListResponse> {
  return api.get<WorkItemLinkListResponse>(`/work-items/${workItemId}/links`);
}

export async function createWorkItemLink(
  workItemId: WorkItemId,
  body: CreateWorkItemLinkRequest,
): Promise<WorkItemLink> {
  return api.post<WorkItemLink>(`/work-items/${workItemId}/links`, body);
}

export async function deleteWorkItemLink(
  workItemId: WorkItemId,
  linkId: string,
): Promise<void> {
  return api.delete(`/work-items/${workItemId}/links/${linkId}`);
}
